const useStyles = {
  textField: {
    paddingRight: '10px',
  },
};

export { useStyles };
